module.exports = __webpack_public_path__ + "static/media/workshop-scratch.6c06050e.jpg";